import * as types from '../mutation-types'
import * as api from '../api'
import router from '../../router'
import _ from 'lodash'

const state = {
  events: [],
  event: {},
  event_steps: [],
  event_step: {},
  event_step_order_types: [],
  event_step_command_types: [],
  event_action_types: [],
  event_summaries: {},
  guided_states: {
    ASK_CREATE_VISUALS: 'ASK_CREATE_VISUALS',
    ASK_CREATE_STEPS: 'ASK_CREATE_STEPS',
    ASK_CREATE_STEPS_AFTER_VISUAL: 'ASK_CREATE_STEPS_AFTER_VISUAL',
    ASK_CREATE_ANOTHER_VISUAL: 'ASK_CREATE_ANOTHER_VISUAL',
    ASK_CREATE_ANOTHER_STEP: 'ASK_CREATE_ANOTHER_STEP'
  }
}

const getters = {
  allEvents: state => state.events,
  singleEvent: state => state.event,
  allEventSteps: state => state.event_steps,
  singleEventStep: state => state.event_step,
  allEventSummaries: state => state.event_summaries,
  allEventStepOrderTypes: state => state.event_step_order_types,
  allEventStepCommandTypes: state => state.event_step_command_types,
  allEventActionTypes: state => state.event_action_types,
  allGuidedStates: state => state.guided_states
}

const actions = {
  getEvents ({ commit }) {
    return api.instance.get('events')
      .then(function (response) {
        const events = response.data.events
        commit(types.RECEIVE_EVENTS, events)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getEvent ({ commit }, eventId) {
    return api.instance.get('event/' + eventId)
      .then(function (response) {
        const event = response.data.event

        if (event.extension === 0) {
          event.extension = '9'
        }

        commit(types.RECEIVE_EVENT, event)
        return event
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  addEditEvent ({ commit, rootGetters }, data) {
    let eventData = data.event
    const next = data.next
    const dialog = this._vm.g2dialog

    eventData.site_id = rootGetters.scopedSiteId

    if (eventData.extension === '') {
      eventData.extension = '9'
    }

    if (eventData.extension === '9') {
      eventData.extension = 0
    }

    if (eventData.name !== '') {
      if (eventData.event_id === 0) {
        return api.instance.post('events', eventData)
          .then(function (response) {
            if (response.data.success === 'true') {
              eventData = response.data.event[0]
              commit(types.ADD_EVENT, eventData)
              if(next === 'EventSummary') {
                router.push({ name: 'EventSummary', params: { event_id: eventData.event_id }})
              }
              return eventData
            } else {
              dialog.$alert(response.data.message)
            }
            return response.data.success === 'true'
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        return api.instance.put('event/' + eventData.event_id, eventData)
          .then(function (response) {
            if (response.data.success === 'true') {
              eventData = response.data.event[0]
              commit(types.EDIT_EVENT, eventData)
              dialog.$alert('Successfully saved.')
            } else {
              dialog.$alert(response.data.message)
            }
            return response.data.success === 'true'
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    } else {
      dialog.$alert('Name is required')
    }
  },
  deleteEvent ({ commit }, event_id) {
    const dialog = this._vm.g2dialog
    return api.instance.delete('event/' + event_id)
      .then(function (response) {
        dialog.$alert(response.data.message)

        if (response.data.success === 'true') {
          commit(types.DELETE_EVENT, event_id)
        }
        return response.data.success === 'true'
      })
  },
  getEventActionTypes ({ commit }) {
    if (!Array.isArray(state.event_action_types) || !state.event_action_types.length) {
      return api.instance.get('event_action_types')
        .then(function (response) {
          const eventActionTypes = response.data.event_action_types
          commit(types.RECEIVE_EVENT_ACTION_TYPES, eventActionTypes)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getEventSteps ({ commit }, eventId) {
    return api.instance.get('event_steps_by_event/' + eventId)
      .then(function (response) {
        const eventSteps = response.data.event_steps
        commit(types.RECEIVE_EVENT_STEPS, eventSteps)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getEventStep ({ commit }, eventStepId) {
    return api.instance.get('event_steps/' + eventStepId)
      .then(function (response) {
        const eventStep = response.data.event_step

        if (!eventStep.barix_command) eventStep.barix_command = ''
        if (!eventStep.sleep_duration) eventStep.sleep_duration = 0
        if (!eventStep.to_event_step_id) eventStep.to_event_step_id = 0
        if (!eventStep.message) eventStep.message = ''
        if (!eventStep.event_step_phone_numbers) eventStep.event_step_phone_numbers = []
        if (!eventStep.visual_id) eventStep.visual_id = 0
        if (!eventStep.advanced_visual_id) eventStep.advanced_visual_id = 0
        if (!eventStep.zone_id) eventStep.zone_id = 0
        if (!eventStep.sound_id) eventStep.sound_id = 0

        if (eventStep.event_step_command_type_id === 1) {
          eventStep.sound = {
            value: eventStep.sound.sound_id,
            label: eventStep.sound.filename
          }
        }

        commit(types.RECEIVE_EVENT_STEP, eventStep)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  addEditEventStep ({ commit, dispatch }, data) {
    let eventStep = data.event_step
    const next = data.next
    const dialog = this._vm.g2dialog

    if (eventStep.event_step_command_type_id === 0) {
      dialog.$alert('Command Type is required.')
      return false
    }

    
    if (eventStep.event_step_command_type_id === 1 && (Number(eventStep.zone_id) === 0 || eventStep.sound === '')) {
      dialog.$alert('Zone and Sound are required.')
      return false
    }

    if (eventStep.event_step_command_type_id === 1) {
      eventStep.sound_id = Number(eventStep.sound.value) || Number(eventStep.sound.sound_id)
    }

    if (eventStep.event_step_command_type_id === 2 &&
      eventStep.barix_command === '') {
      dialog.$alert('Barix Command is required.')
      return false
    }

    if (eventStep.event_step_command_type_id === 3 &&
      eventStep.sleep_duration <= 0) {
      dialog.$alert('Sleep Duration is required and must be greater than 0.')
      return false
    }

    if (eventStep.event_step_command_type_id === 4 &&
      eventStep.to_event_step_id === 0) {
      dialog.$alert('Go to step is required.')
      return false
    }

    if (eventStep.event_step_command_type_id === 5) {
      if (_.isEmpty(eventStep.message)) {
        dialog.$alert('Message is required')
        return false
      }
    }

    if ([7, 8].includes(eventStep.event_step_command_type_id) && (eventStep.zone_id === 0 || eventStep.advanced_visual_id === 0)) {
      dialog.$alert('Zone and Visual are required')
      return false
    }

    if([11,12].includes(eventStep.event_step_command_type_id) && Number(eventStep.zone_id) === 0) {
      dialog.$alert('Zone is required')
      return false
    }

    if (eventStep.event_step_command_type_id === 11 && (eventStep.display_text === '' || eventStep.flasher_type === '')) {
      dialog.$alert('Display Text and Flasher Type are required')
      return false 
    }

    if (eventStep.event_step_command_type_id === 10) {
      dialog.alert('Warning: If you do not enable the system after this step, most features will not work until the service is manually restarted.')
    }

    if (!eventStep.from_template) {
      eventStep.from_template = false
    }

    if (eventStep.event_step_id === 0) {
      return api.instance.post('event_steps', eventStep)
        .then(function (response) {
          if (response.data.success === 'true') {
            const eventSteps = response.data.event_steps
            commit(types.ADD_EVENT_STEPS, eventSteps)
            if(next === 'EventSummary') {
              router.push({ name: 'EventSummary', params: { event_id: eventSteps[0].event_id }})
            }
          } else {
            alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    } else {
      return api.instance.put('event_steps/' + eventStep.event_step_id, eventStep)
        .then(function (response) {
          if (response.data.success === 'true') {
            const eventSteps = response.data.event_steps
            commit(types.EDIT_EVENT_STEPS, eventSteps)
          } else {
            dialog.$alert(response.data.message)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  deleteEventStep ({ commit, dispatch }, eventStep) {
    return api.instance.delete('event_steps/' + eventStep.event_step_id)
      .then(function (response) {
        if (response.data.success === 'true') {
          // commit(types.DELETE_EVENT_STEP, eventStep)
          dispatch('getEventSteps', eventStep.event_id)
        }
      })
  },
  getEventStepOrderTypes ({ commit }) {
    if (!Array.isArray(state.event_step_order_types) || !state.event_step_order_types.length) {
      return api.instance.get('event_step_order_types')
        .then(function (response) {
          const eventStepOrderTypes = response.data.event_step_order_types
          commit(types.RECEIVE_EVENT_STEP_ORDER_TYPES, eventStepOrderTypes)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getEventStepCommandTypes ({ commit }) {
    if (!Array.isArray(state.event_step_command_types) || !state.event_step_command_types.length) {
      return api.instance.get('event_step_command_types')
        .then(function (response) {
          const eventStepCommandTypes = response.data.event_step_command_types
          commit(types.RECEIVE_EVENT_STEP_COMMAND_TYPES, eventStepCommandTypes)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  reorderEventStep ({ commit, state }, params) {
    const dialog = this._vm.g2dialog
    return api.instance.put('event_steps/order/' + params.event_step_id, { fromOrder: params.fromOrder, toOrder: params.toOrder })
      .then(function (response) {
        if (response.data.success === 'true') {
          let eventSteps = response.data.event_steps
          commit(types.RECEIVE_EVENT_STEPS, eventSteps)
        } else {
          dialog.$alert(response.data.message)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getEventSummaries ({ commit }) {
    return api.instance.get('event_summaries')
      .then(function (response) {
        const eventSummaries = response.data.event_summaries
        commit(types.RECEIVE_EVENT_SUMMARIES, eventSummaries)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  playNotification ({ commit }, notification) {
    const dialog = this._vm.g2dialog
    return api.instance.post('uds_message', {
      command: 'play_announcement',
      event_id: notification.event_id
    }).then(function (response) {
      if (response.data.success === 'true') {
        dialog.$alert('Announcement successfully started.')
      } else {
        dialog.$alert(response.data.message)
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  playTextNotification ({ commit }, notification) {
    const dialog = this._vm.g2dialog
    return api.instance.post('uds_message', {
      command: 'execute_text_based_alert',
      display_text: notification.display_text,
      zone_id: notification.zone_id,
      flasher_type: notification.flasher_type,
      action: notification.action,
      duration: notification.duration
    }).then(function (response) {
      if (response.data.success === 'true') {
        const s = notification.action === "start" ? "started" : "stopped"
        dialog.$alert('Text notification successfully ' + s + '.')
      } else {
        dialog.$alert(response.data.message)
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  executeAlert ({ rootGetters }, alertId) {
    const dialog = this._vm.g2dialog
    return api.instance.post('uds_message', {
      command: 'execute_alert',
      event_id: alertId,
      source_id: 2,
      source_user: rootGetters.loggedInUser.username
    }).then(function (response) {
      if (response.data.success === 'true') {
        dialog.$alert('Alert successfully executed.')
        /* eslint-disable-next-line */
        $('#textToSpeechModal').modal('hide')
      } else {
        dialog.$alert(response.data.message)
      }
    }).catch(function (error) {
      console.log(error)
    })
  }
}

const mutations = {
  [types.RECEIVE_EVENTS] (state, events) {
    state.events = events
  },
  [types.RECEIVE_EVENT] (state, event) {
    state.event = event
  },
  [types.ADD_EVENT] (state, event) {
    state.events.push(event)
  },
  [types.EDIT_EVENT] (state, event) {
    let eventToEdit = state.events.find(
      function (ele) {
        if (ele.event_id === event.event_id) {
          return true
        }
      }
    )
    let index = state.events.indexOf(eventToEdit)
    state.events[index] = event
  },
  [types.DELETE_EVENT] (state, event_id) {
    let eventToDelete = state.events.find(
      function (ele) {
        if (ele.event_id === event_id) {
          return true
        }
      }
    )
    let index = state.events.indexOf(eventToDelete)
    state.events.splice(index, 1)
  },
  [types.RECEIVE_EVENT_ACTION_TYPES] (state, eventActionTypes) {
    state.event_action_types = eventActionTypes
  },
  [types.RECEIVE_EVENT_STEPS] (state, eventSteps) {
    state.event_steps = eventSteps
  },
  [types.RECEIVE_EVENT_STEP] (state, eventStep) {
    state.event_step = eventStep
  },
  [types.ADD_EVENT_STEP] (state, eventStep) {
    state.event_steps.push(eventStep)
  },
  [types.ADD_EVENT_STEPS] (state, eventSteps) {
    const oldStepIds = state.event_steps.map(step => step.event_step_id);
    const newStepIds = eventSteps
      .filter(step => !oldStepIds.includes(step.event_step_id))
      .map(step => step.event_step_id);
    
    state.event_steps = eventSteps.map(event_step => {
        return {
          ...event_step,
          is_new: newStepIds.includes(event_step.event_step_id)
        }
    })
  },
  [types.EDIT_EVENT_STEP] (state, eventStep) {
    state.event_steps = state.event_steps.map(step => {
      if(step.event_step_id === eventStep.event_step_id) return { ...eventStep, is_new: true }
      return step
    })
  },
  [types.EDIT_EVENT_STEPS] (state, eventSteps) {
    state.event_steps = state.event_steps.map(step => ({ ...step, is_new: false }))
    setTimeout(() => {
      state.event_steps = state.event_steps.map(step => {
        let newEdit = eventSteps.find(s => s.event_step_id === step.event_step_id)
        if(newEdit) return { ...newEdit, is_new: true }
        return step
      })
    })
  },
  [types.DELETE_EVENT_STEP] (state, eventStep) {
    state.event_steps = state.event_steps.filter(step => step.event_step_id !== eventStep.event_step_id)
  },
  [types.RECEIVE_EVENT_STEP_ORDER_TYPES] (state, eventStepOrderTypes) {
    state.event_step_order_types = eventStepOrderTypes
  },
  [types.RECEIVE_EVENT_STEP_COMMAND_TYPES] (state, eventStepCommandTypes) {
    state.event_step_command_types = eventStepCommandTypes
  },
  [types.RECEIVE_EVENT_SUMMARIES] (state, eventSummaries) {
    state.event_summaries = eventSummaries
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
